import { Component, Input } from '@angular/core';

interface SocialLink {
  url: string;
  title: string;
  iconClass: string;
}

@Component({
  selector: 'app-social-links',
  standalone: true,
  templateUrl: './social-links.html',
  styleUrl: './social-links.scss',
})
export class SocialLinks {
  @Input() marginTop = '30px';

  // Placeholder URLs -- swap for Bulls Barber's real social pages.
  protected readonly links: SocialLink[] = [
    {
      url: 'https://www.facebook.com/blacksheepbarbershopbudapest',
      title: 'Black Sheep Barber Shop Facebook oldala',
      iconClass: 'fab fa-facebook-square fa-lg',
    },
    {
      url: 'https://www.instagram.com/blacksheepbarbershopbp/',
      title: 'Black Sheep Barber Shop Instagram oldala',
      iconClass: 'fab fa-instagram fa-lg',
    },
    {
      url: 'https://www.youtube.com/@blacksheepbarbershop4110',
      title: 'Black Sheep Barber Shop Youtube csatornája',
      iconClass: 'fab fa-youtube fa-lg',
    },
    {
      url: 'https://www.tiktok.com/@blacksheepbarber.bp',
      title: 'Black Sheep Barber Shop TikTok oldala',
      iconClass: 'fab fa-tiktok',
    },
  ];
}
